import { createContext } from "react";
import { AppInterface } from "..";

export const OpenDashContext = createContext<AppInterface>(undefined);
